import useScrollIntoView from 'hooks/useScrollIntoView';
import React, { useRef, useState } from 'react';

const withInputFieldFocus = (Component) => {
  const InputFieldFocusComponent = (props) => {
    const [isFocus, setFocus] = useState(false);

    const focusRef = useRef(null);
    useScrollIntoView(focusRef, isFocus, [isFocus]);

    const { onBlur } = props || {};

    const handleOnBlur = (e) => {
      onBlur(e);
      setFocus(false);
    };

    const handleOnFocus = (e) => {
      setFocus(true);
    };

    const newProps = {
      ...props,
    };
    return (
      <Component
        {...newProps}
        ref={focusRef}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
    );
  };
  return InputFieldFocusComponent;
};

export default withInputFieldFocus;
